import { render, staticRenderFns } from "./CreateNewRoleDialog.vue?vue&type=template&id=216f033a"
import script from "./CreateNewRoleDialog.vue?vue&type=script&lang=js"
export * from "./CreateNewRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports